import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { tenantApi } from '../../api/tenantApi';
import { Panel, Loader, EmptyState, useToast, errText, TenantSelect } from '../ui';

export default function AuditLogs() {
  const toast = useToast();
  const [params] = useSearchParams();
  const [clientCode, setClientCode] = useState(params.get('clientCode') || '');
  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);
  const [res, setRes] = useState(null);

  const load = async (cc, p) => {
    if (!cc) return;
    setRes(null);
    try {
      const data = await tenantApi.getAuditLogs(cc, p, pageSize);
      setRes(data);
    } catch (err) {
      toast.error(errText(err));
      setRes({ data: [] });
    }
  };

  useEffect(() => {
    if (clientCode) load(clientCode, page);
  }, [page]); // eslint-disable-line

  useEffect(() => {
    if (params.get('clientCode')) load(params.get('clientCode'), 1);
  }, []); // eslint-disable-line

  const handleSearch = () => { setPage(1); load(clientCode, 1); };

  const rows = res?.data || [];

  return (
    <>
      <h1 className="page-title">audit_log</h1>
      <p className="page-sub">GET /v1/admin/tenants/logs/audit — change/action trail for a client</p>

      <Panel title="// QUERY">
        <div className="toolbar">
          <div className="toolbar__group">
            <TenantSelect value={clientCode} onSelect={(cc) => setClientCode(cc)} />
            <button className="term-btn term-btn--solid term-btn--sm" onClick={handleSearch}>run_query</button>
          </div>
        </div>

        {!clientCode && <EmptyState>Enter a clientCode to fetch audit logs.</EmptyState>}
        {clientCode && res === null && <Loader label="fetching audit logs" />}
        {clientCode && res !== null && rows.length === 0 && <EmptyState>No audit entries found for {clientCode}.</EmptyState>}

        {res !== null && rows.length > 0 && (
          <>
            <table className="term-table">
              <thead>
                <tr>{Object.keys(rows[0]).map((k) => <th key={k}>{k}</th>)}</tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i}>{Object.values(r).map((v, j) => <td key={j}>{String(v)}</td>)}</tr>
                ))}
              </tbody>
            </table>
            <div className="pager">
              <button className="term-btn term-btn--sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>← prev</button>
              <span>page {res.page} / {res.totalPages} · {res.totalRecords} records</span>
              <button className="term-btn term-btn--sm" disabled={page >= (res.totalPages || 1)} onClick={() => setPage((p) => p + 1)}>next →</button>
            </div>
          </>
        )}
      </Panel>
    </>
  );
}